var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { formTextBackgroundStyles, useFormTextStateProps, } from '../../../context';
import { useAdornmentState } from '../context';
var StyledAdornmentStatic = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), function (_a) {
    var $position = _a.$position, _b = _a.theme, colors = _b.colors, space = _b.space;
    return "\n    display: flex;\n    align-items: center;\n    border: none;\n    border-top-".concat($position, "-radius: 4px;\n    color: ").concat(colors['slate-4'], ";\n    font-weight: normal;\n    white-space: nowrap;\n    padding: 0;\n    padding-").concat($position, ": ").concat(space.xs, ";\n  ");
}, formTextBackgroundStyles);
export var AdornmentStatic = function (_a) {
    var children = _a.children, others = __rest(_a, ["children"]);
    var formTextStateProps = useFormTextStateProps({});
    var position = useAdornmentState().position;
    return (React.createElement(StyledAdornmentStatic, __assign({}, others, formTextStateProps, { "$position": position }), children));
};
var templateObject_1;
//# sourceMappingURL=AdornmentStatic.js.map